import type { QueryKey } from '@tanstack/react-query';

const queryKeys = {
  allCreatives: ['api', 'v1', 'creative_manager', 'get_creatives'] as QueryKey,
  creatives: <TParams>(params?: TParams) => ['api', 'v1', 'creative_manager', 'get_creatives', params] as QueryKey,
};
export default queryKeys;